// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Location = t.struct({
    address1: t.String,
    address2: t.String,
    city: t.String,
    country: t.String,
    postalCode: t.String,
    state: t.String
}, {
    name: 'Location',
    strict: true
});

export const getDefaultState = () => new Location({
    address1: '',
    address2: '',
    city: '',
    country: '',
    postalCode: '',
    state: ''
});

export default Location;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/location.js